// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: false,
    instanceString: 'TRAINING',
    msalConfig: {
        clientId: '04ee73e6-4d07-40c8-adbd-a35a78057884',
        authority: 'https://login.microsoftonline.com/26a873c3-b6e8-4210-b79a-b04ff987154e/', // siopen-r-net tenant: 26a873c3-b6e8-4210-b79a-b04ff987154e
        redirectUri: window.location.origin + '/',
        postLogoutRedirectUri: window.location.origin + '/',
        endpoints: {
            'https://graph.microsoft.com': ['00000003-0000-0000-c000-000000000000/.default'],
            // 'https://graph.windows.net/siopen-r-net.org': ['00000002-0000-0000-c000-000000000000/.default'],
            'https://trial-services.eupid.eu/EUPID': ['7c998b47-e72f-4a86-afc5-79c8c82ab62a/.default'],
            'https://trial-services.eupid.eu/Helper': ['7c998b47-e72f-4a86-afc5-79c8c82ab62a/.default'],
        }
    },
    keycloakConfig: {
        clientId: 'SIOPEN-EUPID-Interface-Client-Training',
        //url: 'http://localhost:8080',
        url: 'https://internal-ait-keycloak-dmcve4h5a0c0d5h2.westeurope-01.azurewebsites.net',
        realm: 'SIOPEN-EUPID-Interface-Login-Training',
        scope: 'phone profile email organization'
    },
    aad: {
        graphApiBaseUrl: 'https://graph.microsoft.com',
        apiVersion: 'v1.0',
        // graphApiBaseUrl: 'https://graph.windows.net/siopen-r-net.org',
        // apiVersion: '?api-version=1.6',
        groupPrefix: 'TRAIN-',
        srnUserGroupId: ''  //needed for userdcptable at the moment - should be removed!
    },
    
    //eupidServiceBaseUrl: 'https://trial-services.eupid.eu',
    //eupidServiceBaseUrl: 'http://localhost:80/eupid',
    eupidServiceBaseUrl: 'https://internal-ait-eupid-reverse-proxy.germanywestcentral.cloudapp.azure.com/eupid',
    hrnbl2BaseUrl: 'https://www.siopen.org/siopen-clinical-trials-1/siopen-high-risk-neuroblastoma-study-2-hr-2',
    monaBaseUrl: 'https://siope.eu/monalisa',
    bioportalBaseUrl: 'https://bioportal-test.siopen-r-net.org/',
    hashConfig: {
        hmacSHA512: {
            hmacKey: 'uxgsDhhaB88721'
        },
        argon2: {
            salt: new Uint8Array([163,221,11,125,106,18,188,111,83,48,79,227,8,199,252,56,3,159,34,192,117,36,129,33,26,159,182,183,231,143,204,73]),
            keylen: 64,
            opsLimit: 3,
            memLimit: 102400
        }
    }
};
